import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-meta-modal',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './app-meta-modal.component.html',
  styleUrl: './app-meta-modal.component.css'
})
export class MetaFormModalComponent {
  @Input() form!: FormGroup;
  @ViewChild('metaModal', { static: true }) metaModal!: TemplateRef<any>;

  constructor(private modalService: NgbModal) {}

  open() {
    this.modalService.open(this.metaModal, { size: 'md' });
  }

  onSave(modal: any) {
    modal.close();
  }
}
